<template>
  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M14.8178 3L24 12.1931L14.8178 21.3753L13.6646 20.2221L20.8776 13.0091L-3.97414e-07 13.0091L-4.68747e-07 11.3772L20.8776 11.3772L13.6646 4.15322L14.8178 3Z"
      fill="currentColor"
    />
  </svg>
</template>

<script>
export default {
  name: "ArrowBackIcon"
}
</script>
